import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Icon, Loader } from "semantic-ui-react";
import { getHomeBorrowerStatementsInfolist } from "../../../api/BorrowerApi";
import { getMockHomeBorrowerStatementsInfolist } from "../../../api/mock/MockBorrowerApi";
import { convertToDateString, formatDataProperties } from "../../../Helpers";
import { IProxyUser } from "../../interfaces/Global";
import BCEmptyState from "../../ui/BCEmptyState";
import BCTable from "../../ui/BCTable";
import "../../../styles/borrower/home.scss";
import { IHomeBorrowerStatementsView } from "../../interfaces/Borrower";
import { FeatureFlags } from "../../constants/LocalServerConstants";

interface IBWBorrowerStatementsContent {
  isApiMessage: string[];
  setIsApiMessage: React.Dispatch<React.SetStateAction<string[]>>;
  proxyUser: IProxyUser | undefined;
  activeOnlyBorrowerStatements: boolean;
}

const BWBorrowerStatementsContent = ({ 
  isApiMessage,
  setIsApiMessage,
  proxyUser,
  activeOnlyBorrowerStatements
} : IBWBorrowerStatementsContent) => {
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [borrowerStatementsInfoData, setBorrowerStatementsInfoData] = useState(undefined as any);

  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const convertToTableFormat = (statements) => {
    const activeBorrowerStatements = statements.filter(statement => statement.status !== "active").slice(0, 6);
    const result = [] as IHomeBorrowerStatementsView[];
    const downloadIcon = <Icon title="Download" name="download" />;
    const formatDataValue = (data) => {
      data.forEach(statement => {
        if (statement.projectName !== null) {
          result.push({
            "loanNumber": statement.loanNumber,
            "project": statement.projectName,
            "statementFor": convertToDateString(statement.effectiveDate),
            "download": downloadIcon
          });
        }
      });
    };
    if (activeOnlyBorrowerStatements) {
      formatDataValue(activeBorrowerStatements);
    }
    else {
      formatDataValue([...statements].slice(0,6));
    }

    return formatDataProperties(result, [{field: "loanNumber", action: "rename", name: "Loan #"}, {field: "download", action: "rename", name: ""}]);
  };

  useEffect(() => {
    const getBorrowerStatementsInfoAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockHomeBorrowerStatementsInfolist() : await getHomeBorrowerStatementsInfolist(proxyUser && proxyUser.id);
        if (response && response.ok) {
          const borrowerStatementsInfo = await response.json();
          setBorrowerStatementsInfoData(borrowerStatementsInfo);
        }
        else {
          FeatureFlags.IS_DEBUG && console.log("Borrower Statements response:");
          FeatureFlags.IS_DEBUG && console.log(response);
          setIsApiMessage([...isApiMessage, "Borrower Statements"]);
        }
      }
      catch (error) {
        handleError();
      }
      
      setIsLoading(false);
    };

    getBorrowerStatementsInfoAsync();
  }, [handleError, proxyUser]);
    
  return (
    <React.Fragment>
      {isLoading ? <div className="borrower-home-loader"><Loader active inline="centered" size="big" /></div> : 
        <React.Fragment>
          {borrowerStatementsInfoData && convertToTableFormat(borrowerStatementsInfoData).length > 0 ? <BCTable 
            dataRules={[{ field: "Id", rule: "hide" }]}
            data={convertToTableFormat(borrowerStatementsInfoData)}
            selectable
            overflowX
            dataSingleLine
            sortable={["Loan Number", "Project", "Statement For"]}
            pagination={15}
          /> 
          : <BCEmptyState
              emptyStateClass="home-content-empty-state"
              icon="list alternate outline"
              text="You currently have no borrower statements"
            />
          }
        </React.Fragment>
      }
      {FeatureFlags.IS_DEBUG && <React.Fragment>
        <button onClick={() => console.log(borrowerStatementsInfoData)}>borrowerStatementsInfoData</button>
        <button onClick={() => console.log(activeOnlyBorrowerStatements)}>activeOnlyBorrowerStatements</button>
      </React.Fragment>}
    </React.Fragment>
  );
};

export default BWBorrowerStatementsContent;